import script from "./CoreProgramBudgetJustification.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreProgramBudgetJustification.vue?vue&type=script&setup=true&lang=js"

import "./CoreProgramBudgetJustification.vue?vue&type=style&index=0&id=b31e172c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b31e172c"]])

export default __exports__